import { createStyles } from "@mantine/emotion";

import { rooterMediaQuery } from "_styles/theme/mediaQuery";

export default createStyles ( theme => {
	return {
		container: {
			display                   : "flex",
			alignItems                : "center",
			backgroundColor           : theme.other.colors.border.secondary,
			borderRadius              : "16px",
			padding                   : "16px",
			width                     : "100%",
			marginBottom              : "2rem",
			marginTop                 : "2rem",
			[rooterMediaQuery.mobile] : {
				width       : "calc(100% - 4rem)",
				marginLeft  : "2rem",
				marginRight : "2rem"
			}

		},
		thumbnailStack: {
			display: "none",

			[rooterMediaQuery.desktop]: {
				display  : "block",
				position : "relative",
				width    : "150px",
				height   : "84.375px" // 150px * 9/16 = 84.375px for 16:9
			}
		},
		first: {
			left         : "4rem",
			zIndex       : 3,
			width        : "14rem",
			aspectRatio  : "16/9",
			borderRadius : "12px",
			position     : "absolute",
			boxShadow    : "0 4px 8px rgba(0, 0, 0, 0.2)",
			transition   : "transform 0.2s",
			top          : "2rem"
		},
		second: {
			left         : "2rem",
			zIndex       : 2,
			width        : "14rem",
			aspectRatio  : "16/9",
			borderRadius : "12px",
			position     : "absolute",
			boxShadow    : "0 4px 8px rgba(0, 0, 0, 0.2)",
			transition   : "transform 0.2s",
			top          : "1rem"
		},
		third: {
			width        : "14rem",
			aspectRatio  : "16/9",
			borderRadius : "12px",
			position     : "absolute",
			boxShadow    : "0 4px 8px rgba(0, 0, 0, 0.2)",
			transition   : "transform 0.2s",
			left         : "0px",
			zIndex       : 1,
			top          : "0rem"
		},
		content: {
			marginLeft : "0",
			flexGrow   : 1,

			[rooterMediaQuery.desktop]: {
				marginLeft: "5.6rem"
			}
		},
		noticeText: {
			marginBottom: "12px"

		},
		strong: {
			fontSize   : "18px",
			color      : theme.other.colors.text.primary,
			display    : "block",
			fontWeight : "700"
		},
		titleWithIcon: {
			display    : "flex",
			alignItems : "center",
			gap        : "0.5rem",
			cursor     : "pointer"
		},
		paragraph: {
			color     : "#666",
			marginTop : "4px",
			fontSize  : "14px"
		},
		button: {
			color        : "#fff",
			padding      : "10px 16px",
			fontSize     : "14px",
			border       : "none",
			borderRadius : "8px",
			cursor       : "pointer",
			fontWeight   : "500"
		},
		modalRoot: {
		},
		modalBody: {
			padding       : "0",
			background    : theme.other.colors.background.tertiary,
			overflow      : "hidden",
			height        : "100%",
			display       : "flex",
			flexDirection : "column"
		},
		modalContent: {
			flexBasis     : "min( 600px, 80vw ) !important",
			background    : theme.other.colors.background.tertiary,
			overflowY     : "auto",
			overflowX     : "hidden",
			height        : "80vh",
			display       : "flex",
			flexDirection : "column",
			borderRadius  : "1.6rem"
		},
		drawerBody: {
			height: "100%"
		},
		drawerContent: {
			height: "100dvh",

			[rooterMediaQuery.mobile]: {
				background: theme.other.paletteNew.secondaryBlack
			}
		}
	};
} );